<template>
  <div class="page">
    <header-gif></header-gif>
    <resume></resume>
    <freelance></freelance>
  </div>
</template>

<script>
import HeaderGif from 'components/HeaderGif'
import Resume from 'components/Resume'
import Freelance from 'components/Freelance'

export default {
  components: {
    HeaderGif,
    Resume,
    Freelance,
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?7a84efba